






























































import { Component, Vue } from 'vue-property-decorator';
import { WorkerWizardModule } from '@/store/modules/workerWizard';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'WorkerWizardComplete',
  components: {  }
})
export default class WorkerWizardComplete extends GiganautVue {

  get creationSucceeded() {
    return WorkerWizardModule.creationSucceeded;
  }

  get wasMerge() {
    return WorkerWizardModule.selectedDuplicateMatch !== null;
  }

  async navigateToWorker() {
    const workerId = WorkerWizardModule.newWorker.id;
    WorkerWizardModule.cleanState();
    this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: workerId } });
  }

  createAnother() {
    WorkerWizardModule.cleanState();
    // Navigate to a fresh worker wizard - use replace to avoid back button issues
    this.$router.replace({ name: PageNames.AgencyWorkerWizard });
  }

  goBack() {
    // Go back to review step
    WorkerWizardModule.newWorker.currentStep = 5;
  }
}
